/* @flow */

import React from 'react';
import { Card } from 'semantic-ui-react';
import ViewNavigationLinkItem from './components/ViewNavigationLinkItem';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => (
  <div>
    <Card.Group itemsPerRow={3}>
      {content.items.map(l => (
        <ViewNavigationLinkItem
          key={l.order}
          link={l}
          defaultResourceStrategy={content.layout.strategy}
        />
      ))}
    </Card.Group>
  </div>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/View.js